<div [ngClass]="{
    'rating-down': change < 0,
    'rating-up': change > 0}" class="px-2 d-flex align-items-center rating rating-down">
    <span style="font-size: 15px;" [ngClass]="{'bx-down-arrow-alt' : change < 0, 'bx-up-arrow-alt' : change > 0}"
        class='bx arrow'></span>
    <span style="font-size: 14px; font-weight: 500;">{{change | abs}}<span *ngIf="isPercentage">%</span></span>
</div>